export default __webpack_public_path__ + "img/fleet-drilldown.8ff8a796.png";